import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail } from 'lucide-react';
import AuthShell from '../../components/auth/AuthShell';
import { AuthHeading, AuthField, AuthInput, PasswordInput, ErrorBanner, CheckBox, PrimaryButton } from '../../components/auth/AuthPrimitives';
import api from '../../utils/axios';

export default function LoginPage({ onLogin }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(true);
  const [errors, setErrors] = useState({});
  const [bannerError, setBannerError] = useState('');
  const [loading, setLoading] = useState(false);

  function validate() {
    const errs = {};
    if (!email) errs.email = 'Enter your email';
    else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) errs.email = 'Use a valid email address';
    if (!password) errs.password = 'Enter your password';
    return errs;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const errs = validate();
    setErrors(errs);
    if (Object.keys(errs).length) return;
    setLoading(true);
    setBannerError('');
    try {
      const { data } = await api.post('/accounts/auth/login/', { login: email, password });
      localStorage.setItem('token', data.tokens.access); // eslint-disable-line no-restricted-properties
      localStorage.setItem('refreshToken', data.tokens.refresh); // eslint-disable-line no-restricted-properties
      onLogin?.();
      navigate('/overview');
    } catch (err) {
      setBannerError(err.response?.data?.error || 'Email or password is incorrect. Try again or reset your password.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthShell onLogoClick={() => navigate('/login')}>
      <form onSubmit={handleSubmit} noValidate>
        <AuthHeading title="Sign in to Meduri" subtitle="Pick up where you left off — denials, appeals, and notes." />
        <ErrorBanner>{bannerError}</ErrorBanner>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <AuthField label="Work email" htmlFor="login-email" error={errors.email}>
            <AuthInput id="login-email" type="email" autoComplete="email" placeholder="you@clinic.com" leadingIcon={Mail} value={email} onChange={e => setEmail(e.target.value)} error={errors.email} />
          </AuthField>
          <AuthField label="Password" htmlFor="login-password" error={errors.password}>
            <PasswordInput id="login-password" value={password} onChange={e => setPassword(e.target.value)} error={errors.password} autoComplete="current-password" />
          </AuthField>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 4 }}>
            <CheckBox checked={remember} onChange={setRemember} label="Keep me signed in" />
            <a onClick={() => navigate('/forgot-password')} style={{ fontSize: 13, color: '#000', textDecoration: 'underline', cursor: 'pointer' }}>Forgot password?</a>
          </div>
          <div style={{ marginTop: 8 }}>
            <PrimaryButton type="submit" loading={loading}>Sign In</PrimaryButton>
          </div>
        </div>
        <div style={{ marginTop: 24, paddingTop: 24, borderTop: '0.4px solid #000', fontSize: 14, color: '#1D2433', textAlign: 'center' }}>
          New to Meduri?{' '}
          <a onClick={() => navigate('/signup')} style={{ color: '#000', textDecoration: 'underline', cursor: 'pointer', fontWeight: 600 }}>Create an account</a>
        </div>
      </form>
    </AuthShell>
  );
}
